import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import BulkRolloverRecommendationQuestionnairePageContent
  from 'Components/AdvisorApp/Viewport/ApexAdminPortal/BulkRolloverRecommendationQuestionnaire/BulkRolloverRecommendationQuestionnairePageContent';
import useCollection from 'Hooks/useCollection';
import useUserContext from 'Context/UserContext';
import fr from 'facet-rest';
import DataContainer from 'Components/UI/DataContainer';
import { displayErrorMessage, displaySuccess } from 'Helpers/FacetNotificationManager';

const style = () => ({
  root: {},
});

const BulkRolloverRecommendationQuestionnairePage = ({
  className,
  classes,
}) => {
  const [loading, setLoading] = useState(true);
  const [loadingErrors, setLoadingErrors] = useState(null);
  const { agentResource } = useUserContext();
  const { collection, setCollection } = useCollection();
  const fetchRolloverRecommendationQuestionnaires = async () => {
    try {
      const RRQCollection = await agentResource.relationship(fr.relationships.rolloverRecommendationQuestionnaire.name).link('related').get();
      setCollection(RRQCollection);
    } catch (e) {
      setLoadingErrors(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (agentResource) {
      fetchRolloverRecommendationQuestionnaires();
    }
  }, [agentResource]);

  const onFailure = (err) => {
    displayErrorMessage(err, err.errors);
  };

  const onSubmit = () => {
    displaySuccess('Rollover Questionnaire successfully updated');
  };

  return (
    <DataContainer
      className={classNames(className, classes.root)}
      loading={loading}
      loadingError={loadingErrors}
      ErrorListProps={{
        title: 'An error occurred while fetching rollover recommendation questionnaires',
      }}
    >
      <BulkRolloverRecommendationQuestionnairePageContent
        rolloverRecommendationQuestionnaireCollection={collection}
        onReset={fetchRolloverRecommendationQuestionnaires}
        onFailure={onFailure}
        onSubmit={onSubmit}
      />
    </DataContainer>
  );
};

BulkRolloverRecommendationQuestionnairePage.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

BulkRolloverRecommendationQuestionnairePage.defaultProps = {
  className: '',
};

export default withStyles(style)(BulkRolloverRecommendationQuestionnairePage);
